import api from '@/services/data/api'

const user = {
  code: function (phone, phone1, success, fail) {
    api.get('/api/1.0/login/code/' + phone + '/' + phone1, success, fail)
  },
  login: function (phone, code, success, fail) {
    api.get('/api/1.0/login/' + phone + '/' + code, success, fail)
  },
  changePhone: function (phone, code, success, fail) {
    api.get('/api/1.0/user/change/phone/' + phone + '/' + code, success, fail)
  },
  changeArea: function (area, success, fail) {
    api.post('/api/1.0/user/change/area/', area, success, fail)
  },
  changeAddress: function (address, success, fail) {
    api.post('/api/1.0/user/change/address/', address, success, fail)
  },
  changeInvoice: function (invoice, success, fail) {
    api.post('/api/1.0/user/change/invoice/', invoice, success, fail)
  },
  getUser: function (success, fail) {
    api.get('/api/1.0/user/', success, fail)
  }
}

const order = {
  save: function (order, saveAddress, success, fail) {
    api.post('/api/1.0/order/pc/' + saveAddress, order, success, fail)
  },
  list: function (state, page, success, fail) {
    api.post('/api/1.0/order/list/' + state, page, success, fail)
  },
  detail: function (orderId, success, fail) {
    api.get('/api/1.0/order/detail/' + orderId, success, fail)
  },
  remove: function (orderId, success, fail) {
    api.get('/api/1.0/order/delete/' + orderId, success, fail)
  },
  cancel: function (orderId, success, fail) {
    api.get('/api/1.0/order/cancel/' + orderId, success, fail)
  },
  invoice: function (orderId, saveInvoice, invoice, success, fail) {
    api.post('/api/1.0/order/invoice/' + orderId + '/' + saveInvoice, invoice, success, fail)
  },
  pay: function (orderId, success, fail) {
    api.get('/api/1.0/order/pay/wechat/' + orderId, success, fail)
  },
  b2b: function (orderId, success, fail) {
    api.get('/api/1.0/order/pay/b2b/' + orderId, success, fail)
  },
  b2bQuery: function (orderId, success, fail) {
    api.get('/api/1.0/order/pay/b2b/query/' + orderId, success, fail)
  },
  delPay: function (orderId, success, fail) {
    api.get('/api/1.0/order/pay/delete/' + orderId, success, fail)
  },
  queryPay: function (orderId, success, fail) {
    api.get('/api/1.0/order/pay/query/' + orderId, success, fail)
  },
  saveVoucher: function (payId, data, success, fail) {
    api.post('/api/1.0/order/voucher/' + payId, data, success, fail)
  },
  askInvoice: function (orderId, data, success, fail) {
    api.post('/api/1.0/order/ask/' + orderId, data, success, fail)
  },
  queryLogistics: function (orderNo, success, fail) {
    api.get('/api/1.0/order/logistics/' + orderNo, success, fail)
  },
  queryLogisticsDetail: function (LogisticsNo, success, fail) {
    api.get('/api/1.0/logistics/' + LogisticsNo, success, fail)
  },
  getInvoiceSplitList: function (orderId, success, fail) {
    api.get('/api/1.0/invoicesplit/' + orderId, success, fail)
  }
}

const data = {
  product: function (success, fail) {
    api.get('/api/1.0/data/product', success, fail)
  },
  org: function (success, fail) {
    api.get('/api/1.0/data/org', success, fail)
  },
  orgProperties: function (success, fail) {
    api.get('/api/1.0/data/orgproperties', success, fail)
  },
  faqs: function (success, fail) {
    api.get('/api/1.0/question/query', success, fail)
  }
}

const serverConfig = {
  popInfo: function (success, fail) {
    api.get('/api/1.0/config/pc/info/pop', success, fail)
  },
  config: function (success, fail) {
    api.get('/api/1.0/config', success, fail)
  }
}

export default {
  user: user,
  order: order,
  data: data,
  serverConfig: serverConfig
}
